import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "export-buttons__container" }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "icon is-svg is-small" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" XLSX ")
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "icon is-svg is-small" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CSV ")
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "icon is-svg is-small" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" PDF ")


import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiMicrosoftExcel,
  mdiTableArrowDown,
  mdiFilePdfOutline,
} from "@mdi/js";

export default /*#__PURE__*/_defineComponent({
  props: {
    xlsxUrl: null,
    csvUrl: null,
    pdfUrl: null,
    label: null
  },
  setup(__props: any) {

const props = __props as {
    xlsxUrl?: string;
    csvUrl?: string;
    pdfUrl?: string;
    label?: string;
  }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("a", {
      class: "button is-success is-light is-outlined",
      href: __props.xlsxUrl
    }, [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_unref(SvgIcon), {
          type: "mdi",
          path: _unref(mdiMicrosoftExcel)
        }, null, 8, ["path"])
      ]),
      _hoisted_5
    ], 8, _hoisted_3),
    _createElementVNode("a", {
      class: "button is-light is-info is-outlined",
      href: __props.csvUrl
    }, [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_unref(SvgIcon), {
          type: "mdi",
          path: _unref(mdiTableArrowDown)
        }, null, 8, ["path"])
      ]),
      _hoisted_8
    ], 8, _hoisted_6),
    _createElementVNode("a", {
      class: "button is-danger is-light is-outlined",
      href: __props.pdfUrl
    }, [
      _createElementVNode("span", _hoisted_10, [
        _createVNode(_unref(SvgIcon), {
          type: "mdi",
          path: _unref(mdiFilePdfOutline)
        }, null, 8, ["path"])
      ]),
      _hoisted_11
    ], 8, _hoisted_9)
  ]))
}
}

})